/* ============================================================================
   generarBorradorSOAP — plantilla de TEXTO en el front.

   Concatena en formato SOAP lo que el médico YA escribió en otras secciones.
   NO genera contenido clínico: si un bloque está vacío, no lo inventa.
   El resultado es siempre editable y no se guarda hasta que el médico sale del
   campo. Nunca se ejecuta solo.
   ========================================================================== */
const t = (v) => (typeof v === "string" ? v.trim() : "");

function hallazgosTexto(filas) {
  return (filas || [])
    .filter((f) => f.cp === true)
    .map((f) => `- ${f.descripcion}${t(f.observacion) ? `: ${t(f.observacion)}` : ""}`)
    .join("\n");
}

function normalesTexto(filas) {
  const n = (filas || []).filter((f) => f.sp === true).map((f) => f.descripcion);
  return n.length ? `Sin hallazgos: ${n.join(", ")}.` : "";
}

export default function generarBorradorSOAP(data) {
  const d = data || {};
  const S = [];
  if (t(d.motivo)) S.push(`Motivo: ${t(d.motivo)}`);
  if (t(d.enfermedad)) S.push(t(d.enfermedad));

  const O = [];
  const sv = d.signos || {};
  const svPares = [
    ["T", sv.temperatura, "°C"],
    ["FC", sv.pulso, "lpm"],
    ["TA", sv.presion, ""],
    ["FR", sv.frecuencia_respiratoria, "rpm"],
    ["SatO2", sv.saturacion_oxigeno, "%"],
    ["Peso", sv.peso, "kg"],
    ["Talla", sv.talla, "m"],
    ["IMC", sv.imc, ""],
  ].filter(([, v]) => t(String(v ?? "")) !== "");
  if (svPares.length) O.push("Signos vitales: " + svPares.map(([k, v, u]) => `${k} ${v}${u}`).join(", ") + ".");

  const rev = [normalesTexto(d.sistemas), hallazgosTexto(d.sistemas)].filter(Boolean).join("\n");
  if (rev) O.push("Revisión por sistemas:\n" + rev);
  const fis = [normalesTexto(d.fisico), hallazgosTexto(d.fisico)].filter(Boolean).join("\n");
  if (fis) O.push("Examen físico:\n" + fis);

  const A = (d.diagnosticos || [])
    .map((x) => `- ${x.diagnostico?.codigo || ""} ${x.diagnostico?.nombre || ""} (${(x.typo_diagnostico || "").toLowerCase()})`.trim())
    .join("\n");

  const P = t(d.plan);

  const bloques = [
    S.length ? `S (Subjetivo)\n${S.join("\n")}` : "",
    O.length ? `O (Objetivo)\n${O.join("\n")}` : "",
    A ? `A (Análisis / Diagnósticos)\n${A}` : "",
    P ? `P (Plan)\n${P}` : "",
  ].filter(Boolean);

  return bloques.join("\n\n");
}
